import type { ReactElement, SVGProps } from "react";

/** A film strip with a colored accent: `getFileIcon`'s glyph for a video
 *  (lib/file-icons.tsx), drawn like ExtensionFileIcon (a tinted body, a 1.5
 *  stroke, round joins) in the shape of the file card's plate in the approved
 *  mockups/file-ask-card-2026-09-24.html. */
export function FilmFileIcon({
  color,
  ...props
}: SVGProps<SVGSVGElement> & { color: string }): ReactElement {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Frame */}
      <rect
        x="3.5"
        y="5"
        width="17"
        height="14"
        rx="2.5"
        fill={color}
        fillOpacity={0.15}
        stroke={color}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      {/* Sprocket rules */}
      <path
        d="M8 5v14M16 5v14M3.5 9.5H8M3.5 14.5H8M16 9.5h4.5M16 14.5h4.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
